import { camelCase, get } from 'lodash'

const FormInput = {
	inheritAttrs: false,
	inject: ['Form'],
	props: {
		prop: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: true
		},
		errorMessage: {
			type: Function
		},
		input: {
			type: Function
		}
	},
	computed: {
		v () {
			return get(this.Form.$v.formData, this.prop)
		},
		required () {
			return 'required' in this.v
		}
	},
	methods: {
		onInputHandler (e) {
			this.v.$model = e.target.value
		}
	},
	render () {
		const { label, v, required } = this
		const id = camelCase(label)
		return (
			<div>
				<label for={id}>
					{label}
					{required && (
						<span class="required">{' '}*</span>
					)}
				</label>
				{this.input ? (
					this.input(this)
				) : (
					<input
						type="text"
						name={id}
						id={id}
						onInput={this.onInputHandler}
						value={this.v.$model}
						attrs={this.$attrs}
					/>
				)}
				{v.$dirty && v.$invalid && (
					<label for="firstName" class="error">
						{this.errorMessage ? this.errorMessage() : `${label} is a required field.`}
					</label>
				)}
			</div>
		)
	}
}

export default FormInput



// WEBPACK FOOTER //
// ./src/components/Form/Input.js